import React, { RefObject, useContext } from "react";
import { Tooltip } from "react-tooltip";
import { GreyInfo } from "./icons";
import {
  PaymentContext,
  PaymentContextValue,
} from "../contexts/Payment/payment.context";

export default function Input({
  title,
  name,
  placeholder,
  type = "text",
  value,
  onChange,
  maskedInput = null,
  prefix = null,
  suffix = null,
  hasTooltip = false,
  tooltipPosition = "right",
  tooltipId = null,
  inputClass = "",
  ...otherProps
}) {
  const ref: RefObject<HTMLInputElement> = React.useRef();
  const { state }: PaymentContextValue = useContext(PaymentContext);
  const { checkoutSettings } = state.business || {};

  return (
    <div className={"flex flex-col space-y-1 relative overflow-visible w-full"}>
      <label
        htmlFor={name}
        className={"flex space-x-1 items-center text-sm text-primary-dark"}
        style={{
          color: checkoutSettings?.fontColor,
        }}
      >
        <div>{title}</div>
        {hasTooltip && (
          <>
            <GreyInfo
              className={"h-3 -mt-0.5 cursor-pointer"}
            />
            <Tooltip
              id={tooltipId}
              place={tooltipPosition as any}
              className="font-normal shadow-sm"
            />
          </>
        )}
      </label>
      <div className={"relative"}>
        {prefix && (
          <div className={"w-10 overflow-hidden absolute left-3 top-3"}>
            {prefix}
          </div>
        )}
        <div>
          <input
            ref={ref}
            id={name}
            name={name}
            placeholder={placeholder}
            type={type}
            value={value}
            onChange={onChange}
            className={`appearance-none text-sm rounded-xl p-4 pb-3 w-full h-12 border bg-[#f8fafc] text-[#1C192D] placeholder:text-gray-400 focus:bg-white ${
              prefix && "pl-14"
            } ${inputClass}`}
            style={{
              borderColor:
                checkoutSettings?.fontColor &&
                `${checkoutSettings?.fontColor}66`,
              color: checkoutSettings?.fontColor,
              outlineColor: checkoutSettings?.fontColor,
            }}
            {...otherProps}
          />
          {maskedInput && (
            <div
              className={`bg-white z-10 text-sm absolute top-4 left-0 ${
                prefix && "ml-14"
              }`}
            >
              {maskedInput(value)}
            </div>
          )}
        </div>
        {suffix && (
          <span className="absolute right-3 top-3 justify-center items-center">
            {suffix}
          </span>
        )}
      </div>
    </div>
  );
}
